import React from 'react';
import PropTypes from 'prop-types';
import humanize from 'underscore.string/humanize';
import underscored from 'underscore.string/underscored';

import ValueViewer from './value-viewer';
import TextInput from './text-input';
import Messages, {messagesShape} from '../messages';
import FormGroup from './form-group';
import Button from '../button';
import style from './style.css';


export default class AuthorsInput extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.arrayOf(
      PropTypes.shape({
        lastname: PropTypes.string.isRequired,
        initials: PropTypes.string
      }).isRequired
    ).isRequired,
    readOnly: PropTypes.bool.isRequired,
    editableByDefault: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    messages: messagesShape.isRequired
  };

  static defaultProps = {
    name: 'authors',
    editableByDefault: true,
    readOnly: false,
    onChange: () => null,
    messages: [],
    value: []
  };

  constructor() {
    super(...arguments);
    this.state = {
      newAuthorValue: ''
    };
  }

  parseAuthor(value) {
    let [lastname, initials] = value.split(/,/, 2);
    lastname = lastname ? lastname : '';
    initials = initials ? initials.replace(/^\s*/, '') : '';
    return {lastname, initials};
  }

  handleExistChange(idx) {
    return val => {
      const {value, onChange} = this.props;
      value[idx] = this.parseAuthor(val);
      onChange(value);
    };
  }

  handleNewChange(value) {
    const {lastname, initials} = this.parseAuthor(value);
    this.setState({newAuthorValue: `${lastname}, ${initials}`});
  }

  handleFreshPaste(value, e) {
    e.preventDefault();
    const {onChange, value: authors} = this.props;
    let lastnameFirst = true;
    if (value.startsWith('<')) {
      value = value.slice(1);
      lastnameFirst = false;
    }
    else if (value.startsWith('>')) {
      value = value.slice(1);
    }
    value = value.replace(/\band\b/g, '');
    value = value.split(/;/.test(value) ? /;\d*/g : /,\d*/g);
    for (const v of value) {
      let initials;
      let lastname = v.trim().split(/[, ]/);
      if (lastnameFirst) {
        initials = lastname.slice(1);
        lastname = lastname[0];
      }
      else {
        initials = lastname.slice(0, lastname.length - 1);
        lastname = lastname[lastname.length - 1];
      }
      initials = initials.join(' ');
      lastname = lastname.trim();
      initials = initials ? initials.trim() : '';
      initials = initials.replace(/[a-z\d. ]+/g, '');
      if (/\d$/.test(initials)) {
        initials = initials.replace(/\d+$/, '');
      }
      authors.push({lastname, initials});
    }
    onChange(authors);
    this.setState({newAuthorValue: ''});
  }

  handleRemove(idx) {
    return e => {
      e.preventDefault();
      const {onChange, value} = this.props;
      value.splice(idx, 1);
      onChange(value);
    };
  }

  handleAddButtonClick() {
    const {newAuthorValue: val} = this.state;
    let {value, onChange} = this.props;
    value = [].concat(value);
    value.push(this.parseAuthor(val));
    onChange(value);
    this.setState({newAuthorValue: ''});
  }

  render() {
    const {
      name, label, value, messages, readOnly
    } = this.props;
    const {newAuthorValue} = this.state;
    const _name = underscored(name);

    return (
      <FormGroup className={style.authorinput}>
        <label htmlFor={_name}>{label ? label : humanize(name)}: </label>
        <div className={style.multiple}>
          {value.map(({lastname, initials}, idx) => (
            <div className={style.oneOfMultiple} key={idx}>
              <TextInput
               name={`${name}${idx}`}
               editableByDefault={false} readOnly={readOnly}
               delimiter=", " noLabel value={`${lastname}, ${initials}`}
               placeholder={['Lastname', 'Initials']}
               valueViewerProps={{
                  extraOperations: (
                    readOnly ? null : <a href="#" onClick={this.handleRemove(idx)}>
                      (del)
                    </a>
                  )
                }}
               onChange={this.handleExistChange(idx)} />
            </div>
          ))}
          {readOnly ?
            null : [
              <TextInput
               name={name} key={0}
               onFreshPaste={this.handleFreshPaste.bind(this)}
               delimiter=", " noLabel value={newAuthorValue}
               placeholder={['Lastname', 'Initials']}
               onChange={this.handleNewChange.bind(this)} />,
              <Button
               onClick={this.handleAddButtonClick.bind(this)}
               key={1} type="button">+</Button>
            ]
          }
          {value.length === 0 && readOnly ? <ValueViewer readOnly={readOnly} /> : null}
        </div>
        {messages.length ? <Messages messages={messages} /> : null}
      </FormGroup>


    );
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/authors-input.js